var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.594,
    height: 58.519,
    viewBox: "0 0 41.594 58.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-svgrepo-com",
    transform: "translate(-42.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(42.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M67.491,112.071a11.553,11.553,0,0,1,15.238-10.956l.962-11.544H47.163L50.024,123.9a7.18,7.18,0,0,0,7.114,6.545h16.58a7.18,7.18,0,0,0,7.114-6.545l.034-.41a11.557,11.557,0,0,1-13.374-11.416Z",
    transform: "translate(-46.333 -71.922)",
    fill: "#00824f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M172.828,158.714a8.876,8.876,0,1,0,8.876,8.876A8.886,8.886,0,0,0,172.828,158.714Zm4.355,11.333a1.342,1.342,0,0,1-1.9,1.9l-2.457-2.457-2.457,2.457a1.342,1.342,0,0,1-1.9-1.9l2.457-2.457-2.457-2.457a1.342,1.342,0,0,1,1.9-1.9l2.457,2.457,2.457-2.457a1.342,1.342,0,0,1,1.9,1.9l-2.457,2.457Z",
    transform: "translate(-140.111 -127.442)",
    fill: "#00824f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M101.16,5.143a2.462,2.462,0,0,1,2.46-2.46h6.021a2.462,2.462,0,0,1,2.46,2.46V6.819h2.683V5.143A5.149,5.149,0,0,0,109.641,0H103.62a5.149,5.149,0,0,0-5.143,5.143V6.819h2.683Z",
    transform: "translate(-87.537)",
    fill: "#00824f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M81.139,51.265A3.041,3.041,0,0,0,78.1,48.228H45.989a3.041,3.041,0,0,0-3.037,3.037v2.426H81.139Z",
    transform: "translate(-42.952 -38.725)",
    fill: "#00824f"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.52d181ed20ae88903d116f8e26267f0a.svg";
export { ForwardRef as ReactComponent };